import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/upload-instructions/good.png'
import _imports_1 from '@/assets/upload-instructions/bad1.png'
import _imports_2 from '@/assets/upload-instructions/bad2.svg'
import _imports_3 from '@/assets/upload-instructions/tip1.png'
import _imports_4 from '@/assets/upload-instructions/tip2.png'


const _withScopeId = n => (_pushScopeId("data-v-6da8c390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-tips" }
const _hoisted_2 = { class: "page-one" }
const _hoisted_3 = { class: "container__standard-header" }
const _hoisted_4 = { class: "photo-tips__container" }
const _hoisted_5 = {
  ref: "swiper",
  class: "swiper-container"
}
const _hoisted_6 = { class: "swiper-wrapper" }
const _hoisted_7 = { class: "swiper-slide" }
const _hoisted_8 = { class: "slide-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ok",
  class: "instructions__example"
}, null, -1))
const _hoisted_10 = { class: "slide-text" }
const _hoisted_11 = { class: "slide-text" }
const _hoisted_12 = { class: "swiper-slide swiper-slide--bad" }
const _hoisted_13 = { class: "slide-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "ok",
  class: "instructions__example"
}, null, -1))
const _hoisted_15 = { class: "slide-text" }
const _hoisted_16 = { class: "slide-text" }
const _hoisted_17 = { class: "swiper-slide swiper-slide--bad" }
const _hoisted_18 = { class: "slide-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "ok",
  class: "instructions__example"
}, null, -1))
const _hoisted_20 = { class: "slide-text" }
const _hoisted_21 = { class: "slide-text" }
const _hoisted_22 = { class: "photo-tips__bottom" }
const _hoisted_23 = { class: "photo-tips__grid" }
const _hoisted_24 = { class: "photo-tips__item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_26 = { class: "photo-tips__item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_28 = {
  key: 0,
  class: "text-center"
}
const _hoisted_29 = { class: "row row--navigation-btn d-flex justify-center pb-70" }
const _hoisted_30 = {
  key: 0,
  class: "row row--navigation-btn d-flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row websdk-instructions", { isPopup: _ctx.isPopup }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.howTakePictureHeader`)), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.goodExample`)), 1),
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.devicePosition`)), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.fillEntireFrame`)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.badExample`)), 1),
                _hoisted_14,
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.avoidHorizontalDocument`
                                        )), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.avoidBlurry`)), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.badExample`)), 1),
                _hoisted_19,
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.avoidHorizontalDevice`
                                        )), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.autoCaptureOnTitle`
                                        )), 1)
              ])
            ])
          ], 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.TipsForQuality`)), 1),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", null, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.autoCaptureOnTitle`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.autoCaptureOnText`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", null, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.doNotCoverDataTitle`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.doNotCoverDataText`)), 1)
            ])
          ])
        ]),
        (!_ctx.isPopup)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.readyToTakePhoto`)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          (!_ctx.isPopup)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button button-biger button--submit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleHowToTakePictureInfo()))
                }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.LetsTakePicture`)), 1)
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "button button-biger button--submit photo-instructions-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClosePopup && _ctx.handleClosePopup(...args)))
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.Close`)), 1))
        ])
      ])
    ])
  ], 2))
}